<template>
  <div style="width: 100%;">
    <span>微信添加状态</span>
    <div style="width:100%;display: flex;" class="five">
      <div id="five" style="width:100%; height:200px">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props:{
    list4:Array
  },
  name: "",
  data() {
    return {

    }
  },
  mounted() {
    this.initBie()
  },
  methods: {
    initBie() {
      let chartDom = document.getElementById('five');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#F5D5DC',
          '#E5195A',
          '#fc8452',
          '#9a60b4'],
        title: {
          text: '',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: this.list4,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }

    }
  },
  watch: {
    list4: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped>
.five {
  padding-left: 20px;
}
</style>




// WEBPACK FOOTER //
// src/statistics/components/income4.vue